export const action = (parentVue, index) => {
    return {
        width: 180,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable[index];
            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create",
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    },
                },
            });

            const actionDivArray = [editBtn];

            return h("div", actionDivArray);
        },
    };
};

export const deleteAction = (parentVue, index) => {
    return {
        width: 80,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable[index];
            const deleteBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: "md-trash",
                },
                on: {
                    click: () => {
                        vm.$Modal.confirm({
                            title: "Do you want delete?",
                            content: "",
                            okText: vm.$i18n.t("rcmtable.confirmText"),
                            cancelText: vm.$i18n.t("rcmtable.cancelText"),
                            onOk: () => {
                                var deleteItem = Object.assign({}, params.row);
                                delete deleteItem._index;
                                delete deleteItem._rowKey;

                                vm.actionType = "delete";
                                vm.updateData(vm.esIndex, "delete", deleteItem);
                            },
                        });
                    },
                },
            });

            const actionDivArray = [deleteBtn];

            return h("div", actionDivArray);
        },
    };
};



// WEBPACK FOOTER //
// ./src/view/monitor/fields.js